import React from 'react'
import { Skeleton } from 'antd'
import ClientCardHolder from '../styles/clientCardStyle'
import FolderCardHolder from '../styles/folderCardStyle'
import AdCardHolder from '../styles/adCardStyle'
import AdGridHolder from '../styles/adGridStyle'
import SkeletonBlock from '../styles/skeletonStyle'

// Loading placeholders that mirror each card's layout by reusing the real
// Holder (same padding/min-width/borders/grid). The `.is-skeleton` class on each
// Holder drops the hover/cursor affordances. Used by ClientsSection,
// BrandsSection, FoldersGroup and AdsSection while their data loads.

// Mirrors ClientCard: a name line + the square logo box.
export const ClientCardSkeleton = () => (
  <ClientCardHolder className="is-skeleton">
    <div className="client-info">
      <SkeletonBlock style={{ width: 120, height: 16 }} />
    </div>
    <div className="client-logo">
      <SkeletonBlock style={{ width: '100%', height: '100%' }} />
    </div>
  </ClientCardHolder>
)

// Mirrors FolderCard (used for both brands and folders): square icon + name and
// items lines.
export const FolderCardSkeleton = () => (
  <FolderCardHolder className="is-skeleton">
    <div className="folder-info">
      <SkeletonBlock style={{ width: 32, height: 32, flexShrink: 0 }} />
      <div className="folder-text" style={{ flex: 1 }}>
        <SkeletonBlock style={{ width: '70%', height: 14 }} />
        <SkeletonBlock style={{ width: 48, height: 12 }} />
      </div>
    </div>
  </FolderCardHolder>
)

// Mirrors AdCard in grid view: thumbnail block + title and meta lines.
export const AdCardSkeleton = () => (
  <AdCardHolder className="grid-view is-skeleton">
    <div className="thumbnail">
      <SkeletonBlock style={{ width: '100%', height: '100%', borderRadius: 0 }} />
    </div>
    <div className="info">
      <SkeletonBlock style={{ width: '85%', height: 13 }} />
      <div className="meta">
        <SkeletonBlock style={{ width: 48, height: 12 }} />
        <SkeletonBlock style={{ width: 60, height: 12 }} />
      </div>
    </div>
  </AdCardHolder>
)

// A grid of ad skeletons matching AdGrid's grid view.
export const AdsGridSkeleton = ({ count = 4 }) => (
  <AdGridHolder className="grid-view">
    {Array.from({ length: count }).map((_, i) => (
      <AdCardSkeleton key={i} />
    ))}
  </AdGridHolder>
)

// Unified loading placeholder for the AdsSection content area (folders + ads).
// Rendered in a single place by AdsSection so the loaders aren't spread across
// FoldersGroup/AdGrid. Mirrors the real DOM: two `.ads-group` blocks (the
// `.folders-row` grid + the ad grid), or antd line skeletons in list view.
export const AdsContentSkeleton = ({ viewMode = 'grid', folderCount = 4, adCount = 4 }) => {
  if (viewMode === 'list') {
    return (
      <>
        <div className="ads-group">
          <Skeleton active title={false} paragraph={{ rows: 4 }} />
        </div>
        <div className="ads-group">
          <Skeleton active title={false} paragraph={{ rows: 6 }} />
        </div>
      </>
    )
  }
  return (
    <>
      <div className="ads-group">
        <div className="folders-row">
          {Array.from({ length: folderCount }).map((_, i) => (
            <FolderCardSkeleton key={i} />
          ))}
        </div>
      </div>
      <div className="ads-group">
        <AdsGridSkeleton count={adCount} />
      </div>
    </>
  )
}
